import { Skeleton } from '@design-system/Skeleton';

export const ShopLandingPageSkeleton = () => {
  return (
    <div className="page-container mx-auto px-4 py-6 animate-pulse">
      <div className="flex justify-center mb-8">
        <div className="flex rounded-full p-1 space-x-1">
          <Skeleton className="h-10 w-32 rounded-full" />
          <Skeleton className="h-10 w-32 rounded-full" />
          <Skeleton className="h-10 w-24 rounded-full" />
        </div>
      </div>
    </div>
  );
};
